// Concentration Solution units with conversion factors to kilogram per liter (kg/L)
export const concentrationSolutionUnits = [
  { id: 'kilogram-per-liter', name: 'Kilogram per Liter', symbol: 'kg/L', plural: 'Kilograms per Liter', factor: 1 },
  { id: 'gram-per-liter', name: 'Gram per Liter', symbol: 'g/L', plural: 'Grams per Liter', factor: 0.001 },
  { id: 'milligram-per-liter', name: 'Milligram per Liter', symbol: 'mg/L', plural: 'Milligrams per Liter', factor: 1e-6 },
  { id: 'microgram-per-liter', name: 'Microgram per Liter', symbol: 'μg/L', plural: 'Micrograms per Liter', factor: 1e-9 },
  { id: 'nanogram-per-liter', name: 'Nanogram per Liter', symbol: 'ng/L', plural: 'Nanograms per Liter', factor: 1e-12 },
  { id: 'gram-per-100ml', name: 'Gram per 100mL', symbol: 'g/100mL', plural: 'Grams per 100mL', factor: 0.01 },
  { id: 'milligram-per-milliliter', name: 'Milligram per Milliliter', symbol: 'mg/mL', plural: 'Milligrams per Milliliter', factor: 0.001 },
  { id: 'microgram-per-milliliter', name: 'Microgram per Milliliter', symbol: 'μg/mL', plural: 'Micrograms per Milliliter', factor: 1e-6 },
  { id: 'kilogram-per-cubic-meter', name: 'Kilogram per Cubic Meter', symbol: 'kg/m³', plural: 'Kilograms per Cubic Meter', factor: 0.001 },
  { id: 'gram-per-cubic-centimeter', name: 'Gram per Cubic Centimeter', symbol: 'g/cm³', plural: 'Grams per Cubic Centimeter', factor: 1 },
  { id: 'pound-per-gallon-us', name: 'Pound per Gallon (US)', symbol: 'lb/gal', plural: 'Pounds per Gallon (US)', factor: 0.119826427 },
  { id: 'pound-per-cubic-foot', name: 'Pound per Cubic Foot', symbol: 'lb/ft³', plural: 'Pounds per Cubic Foot', factor: 0.016018463 },
  { id: 'parts-per-million', name: 'Parts per Million', symbol: 'ppm', plural: 'Parts per Million', factor: 1e-6 },
  { id: 'parts-per-billion', name: 'Parts per Billion', symbol: 'ppb', plural: 'Parts per Billion', factor: 1e-9 },
];

export const popularConcentrationSolutionConversions = [
  { from: 'gram-per-liter', to: 'milligram-per-liter' },
  { from: 'milligram-per-liter', to: 'gram-per-liter' },
  { from: 'milligram-per-liter', to: 'parts-per-million' },
  { from: 'parts-per-million', to: 'milligram-per-liter' },
  { from: 'gram-per-liter', to: 'milligram-per-milliliter' },
  { from: 'parts-per-billion', to: 'microgram-per-liter' },
];

export const getUnitById = (id) => concentrationSolutionUnits.find(unit => unit.id === id);

export const convertConcentrationSolution = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert solution concentration units and learn the conversion formula.`;
};
